import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'

import Quote from '../quote'
import TextGradient from '../gradient'
import Banner from '../banner'
import MetaData from '../metadata'
import Footer from '../footer'
import InlineVideo from '../video/inline'

import styles from './styles'


const ThingContent = ({ thing, metadata, classes }) => (
  <div>
    <MetaData data={metadata} />
    <Banner
      uid={`thing_${thing.type.toLowerCase()}`}
      title={thing.title}
      subtitle={thing.subtitle}
    />
    <Intro thing={thing} />
    {thing.contents && <Contents thing={thing} />}
    <Footer />
  </div>
)

const Intro = withStyles(styles)(props => {
  const { classes, thing } = props
  return (
    <div className={'servicesA'}>
      <div className={classes.thing}>
        <div className={classes.contents}>
          <div className={classes.centred}>
            <Grid container spacing={0}>
              <Grid item>
                <Typography variant="subheading">
                  {thing.subtitle.text}
                </Typography>
                <Typography variant="display1" className={classes.title}>
                  <TextGradient
                    text={thing.title.text}
                    fromColor="#333"
                    toColor="#999"
                    direction="left"
                  />
                </Typography>
              </Grid>
              <div
                dangerouslySetInnerHTML={{
                  __html: thing.intro && thing.intro.html,
                }}
                className={classes.text}
              />
            </Grid>
          </div>
        </div>
      </div>
    </div>
  )
})

const Contents = withStyles(styles)(props => {
  const { classes, thing } = props
  return thing.contents.map((content, i) => {
    if (content == null) { // FIXME: Optional chaining?
      return
    }
    switch (content.type) {
      case 'PrismicCtThingBodyVideo':
        return <VideoBlock key={i} content={content} />
      case 'PrismicCtThingBodyBlock':
        return <ContentBlock key={i} content={content} />
      case 'PrismicCtThingBodyQuote':
        return (
          <Quote
          key={i}
            quote={{
              author: content.primary.author,
              quote: content.primary.quote,
            }}
          />
        )
        break
      case 'PrismicCtThingBodyEyecandy':
        return <Candy key={i} content={content} />
        break
      case 'PrismicCtThingBodyTakeaways':
        return <Takeaway key={i} content={content} />
        break
      default:
        break
    }
  })
})


const VideoBlock = withStyles(styles)(props => {
  const { content, classes } = props
  return (
    <div className={'servicesA'}>
      <div className={classes.thing}>
        <div className={classes.contents}>
          <div className={classes.centred}>
            {
              <InlineVideo
                urls={content.primary.video_data.urls}
                poster={content.primary.video_data.poster}
              />
            }
          </div>
        </div>
      </div>
    </div>
  )
})

const ContentBlock = withStyles(styles)(props => {
  const { content, classes } = props
  return (
    <div className={'servicesA'}>
      <div className={classes.thing}>
        <div className={classes.contents}>
          <div className={classes.centred}>
            {
              content.items.map((item, i) => {
                return (
                  <Grid key={i} container spacing={0} style={{marginBottom: '20px'}}>
                    <Grid item>
                      <Typography variant="display1" className={classes.title}>
                        {
                          item.block_title &&
                          <TextGradient
                            text={item.block_title.text}
                            fromColor="#333"
                            toColor="#999"
                            direction="left"
                          />
                        }
                      </Typography>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.block_text && item.block_text.html,
                        }}
                        className={classes.text}
                        style={{flex:1}}
                      />
                    </Grid>
                  </Grid>
                )
              })
            }
          </div>
        </div>
      </div>
    </div>
  )
})

const Candy = withStyles(styles)(props => {
  const { content, classes } = props
  return (
    <div className={'servicesA'}>
      <div className={classes.thingCandy}>
        <div className={classes.contents}>
          <div className={classes.centred}>
            <Grid container spacing={0}>
              <Grid item>
                <Typography variant="display1" className={classes.candyTitle}>
                  {/* {content.primary.eyecandy_title.text} */}
                  <TextGradient
                    text={content.primary.eyecandy_title.text}
                    fromColor="#333"
                    toColor="#999"
                    direction="left"
                  />
                </Typography>
                <Typography className={classes.candyText}>
                  {content.primary.eyecandy_text.text}
                </Typography>
              </Grid>
              <Grid container spacing={40}>
                {content.items.map((item, index) => {
                  return (
                    <Grid key={index} item xs={12} sm={4}>
                      <Img sizes={item.candy_image.sizes} />
                    </Grid>
                  )
                })}
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  )
})

const Takeaway = withStyles(styles)(props => {
  const { content, classes } = props
  return (
    <div className={'servicesA'}>
      <div className={classes.thingTakeaway}>
        <div className={classes.contents}>
          <div className={classes.centred}>
            <Grid container spacing={0}>
              <Grid item>
                <Typography
                  variant="display1"
                  className={classes.takeawayTitle}
                >
                  {content.primary.takeaway_title.text}
                </Typography>
                <Typography className={classes.takeawayText}>
                  {content.primary.takeaway_text.text}
                </Typography>
              </Grid>
              <Grid container spacing={32}>
                {content.items.map((item, index) => {
                  return (
                    <Grid key={index} item xs={12} sm={4}>
                      <Typography
                        variant="subheading"
                        className={classes.takeawayDownloadTitle}
                      >
                        {item.download_title.text}
                      </Typography>
                      <Typography className={classes.takeawayDownloadText}>
                        {item.download_text.text}
                      </Typography>
                      <a
                        href={`${item.download.url}`}
                        target="_new"
                        style={{ textDecoration: 'none' }}
                      >
                        <Button
                          size="small"
                          variant="outlined"
                          className={classes.takeawayDownloadButton}
                        >
                          Download
                        </Button>
                      </a>
                    </Grid>
                  )
                })}
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  )
})

export default withStyles(styles)(ThingContent)



// WEBPACK FOOTER //
// ./src/components/thing/index.js